import { createContext } from '@lit/context';
import { LitElement } from 'lit';

export interface ValidationConfiguratorContextType {
  showValidationMessages: { [key: string]: boolean };
  showValidationSnackbar: boolean | string;
}

export const GlobalValidationConfiguratorContext =
  createContext<ValidationConfiguratorContextType>(
    Symbol('ValidationConfiguratorContext'),
  );

/**
 * Initializes the validation configurator context with default values.
 *
 * This function returns an object representing the initial state of the
 * validation configurator context. The returned object contains default
 * values for `showValidationMessages` and `showValidationSnackbar`.
 *
 * @returns An object representing the initial validation configurator context.
 */
export const initValidationConfiguratorContext =
  (): ValidationConfiguratorContextType => {
    return {
      showValidationMessages: {},
      showValidationSnackbar: false,
    };
  };

/**
 * Dispatches a custom event to update the validation configurator context.
 * @param element - The LitElement from which the event is dispatched.
 * @param data - The updated validation configurator context data.
 */
export const updateValidationConfiguratorContext = (
  element: LitElement,
  data: ValidationConfiguratorContextType,
) => {
  element.dispatchEvent(
    new CustomEvent<{ context: ValidationConfiguratorContextType }>(
      'validation-configurator-context-update',
      {
        composed: true,
        detail: {
          context: data,
        },
      },
    ),
  );
};
